import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../../lib/motion";

export const SectionHeading = ({ eyebrow, title, accent, subtitle, align = "center", testid }) => (
  <motion.div
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={viewportOnce}
    data-testid={testid}
    className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : "text-left"}`}
  >
    {eyebrow && (
      <p className="mb-4 text-xs uppercase tracking-[0.3em] text-gold-light md:text-sm">
        {eyebrow}
      </p>
    )}
    <h2 className="font-display text-4xl font-light leading-[1.05] tracking-tight text-white md:text-5xl lg:text-6xl">
      {title} {accent && <span className="text-gold-gradient italic">{accent}</span>}
    </h2>
    {subtitle && (
      <p className="mt-5 text-base font-light leading-relaxed text-white/65 md:text-lg">
        {subtitle}
      </p>
    )}
  </motion.div>
);
